export default __webpack_public_path__ + "static/media/_DUA5009.1ae1253a.jpg";